import { BreadcrumbsModule } from '@exalif/ngx-breadcrumbs';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { GenericPanelComponent } from './generic-panel/generic-panel.component';
import { NgxPermissionsModule } from 'ngx-permissions';

import { FormInputLayoutComponent } from './form-input-layout/form-input-layout.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWarehouse, faPercentage, faHashtag, faEuroSign, faMale, faTruck } from '@fortawesome/free-solid-svg-icons';

import { GenericContainerComponent } from './generic-container/generic-container.component';
import { GenericSmartModalComponent } from './generic-smart-modal/generic-smart-modal.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { LogoutLayoutComponent } from './logout-layout/logout-layout/logout-layout.component';
import { BootstrapAlertComponent } from './bootstrap-alert/bootstrap-alert.component';
import { MessageDialog } from './message-dialog/messageDialog';
import { DxLoadPanelModule } from 'devextreme-angular';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbCollapse, NgbCollapseModule, NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { ErrorComponent } from './error/error.component';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ButtonMenuItemComponent } from './button-menu/button-menu-item/button-menu-item.component';
import { ButtonMenuItemPopupComponent } from './button-menu-popup/button-menu-item-popup/button-menu-item-popup.component';
import { CompanySelectorComponent } from './filters/company-selector/company-selector.component';
import { YearSelectorComponent } from './filters/year-selector/year-selector.component';
import { EmployeeSelectorComponent } from './filters/employee-selector/employee-selector.component';
import { JobSelectorComponent } from './filters/job-selector/job-selector.component';
import { MatSelectFilteredComponent } from './mat-select-filtered/mat-select-filtered.component';
import { CompanyPayConceptsSelectorComponent } from './filters/company-pay-concepts-selector/company-pay-concepts-selector.component';
import { DayMonthPickerComponent } from './day-month-picker/day-month-picker.component';
import { DayMonthHeaderComponent } from './day-month-picker/day-month-header/day-month-header.component';



library.add(faWarehouse, faPercentage, faHashtag, faEuroSign, faMale, faTruck);

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgxPermissionsModule,
    BreadcrumbsModule,
    DxLoadPanelModule,
    NgxSmartModalModule,
    NgbCollapseModule,
    FontAwesomeModule,
    MaterialModule,
    NgxMatSelectSearchModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbTooltipModule,
    FontAwesomeModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    GenericPanelComponent,
    FormInputLayoutComponent,
    GenericContainerComponent,
    GenericSmartModalComponent,
    LogoutLayoutComponent,
    BootstrapAlertComponent,
    LoginLayoutComponent,
    ErrorComponent,
    BreadcrumbComponent,
    ButtonMenuItemComponent,
    ButtonMenuItemPopupComponent,
    CompanySelectorComponent,
    YearSelectorComponent,
    EmployeeSelectorComponent,
    JobSelectorComponent,
    MatSelectFilteredComponent,
    CompanyPayConceptsSelectorComponent,
    DayMonthPickerComponent,
    DayMonthHeaderComponent
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    GenericPanelComponent,
    FormInputLayoutComponent,
    GenericContainerComponent,
    GenericSmartModalComponent,
    LogoutLayoutComponent,
    BootstrapAlertComponent,
    LoginLayoutComponent,
    BreadcrumbComponent,
    ErrorComponent,
    ButtonMenuItemComponent,
    ButtonMenuItemPopupComponent,
    CompanySelectorComponent,
    YearSelectorComponent,
    EmployeeSelectorComponent,
    JobSelectorComponent,
    MatSelectFilteredComponent,
    CompanyPayConceptsSelectorComponent,
    DayMonthPickerComponent,
    DayMonthHeaderComponent
  ],
  providers: [
    MessageDialog
  ]
})
export class ComponentsModule {}
